import React from 'react';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import { ModuleType } from '..';
import { ContentList } from '../../ContentList';
import { itemToSearchHit, SearchHit } from '../../Search';
import { Filter } from '../../ContentList/filterType';
import { EventType } from '../../Event';
import { gray90 } from '@spotify-internal/encore-foundation';

export type ContentListModuleType = ModuleType & {
  items?: EventType[];
};

export const EventListModule: React.FC<ContentListModuleType> = ({
  id = '',
  items = [],
}) => {
  const [events, setEvents] = React.useState<SearchHit[]>();
  const [filters, setFilters] = React.useState<Filter[]>();

  const today = new Date();

  React.useEffect(() => {
    const filteredEvents = items
      .map(itemToSearchHit)
      .filter(Boolean)
      .filter(
        item =>
          item!.date &&
          Date.parse(item!.date) >= today.setDate(today.getDate() - 1),
      )
      .sort((a, b) => {
        // TODO Handle these exclamation points
        return Date.parse(a!.date!) - Date.parse(b!.date!);
      }) as NonNullable<SearchHit[]>;
    setEvents(filteredEvents);

    const franchiseFilters = Array.from(
      new Set(filteredEvents.map(({ label }) => label)),
    )
      .filter(Boolean)
      .sort();

    const locationFilters = Array.from(
      new Set(filteredEvents.map(({ location }) => location)),
    )
      .filter(Boolean)
      .sort();

    setFilters([
      {
        filterValue: 'label',
        allLabel: 'All event types',
        filterOptions: franchiseFilters,
      },
      {
        filterValue: 'location',
        allLabel: 'All locations',
        filterOptions: locationFilters,
      },
    ] as NonNullable<Filter[]>);
  }, [items]);

  const emptyMessage =
    events?.length === 0
      ? 'We currently do not have any upcoming events.'
      : 'No events matched the specified filters.';

  return (
    (events && filters && (
      <ContentList
        data-testid={`contentList--module-${id}`}
        items={events}
        filterBarTitle="Upcoming events"
        filters={filters}
        filterBarColor={gray90}
        emptyMessage={emptyMessage}
        showFilters={events.length > 1}
      />
    )) || <LoadingIndicator />
  );
};
